/**
 * Default function for the SDK to use for log formatting.
 *    Uses entry information to form a prefix.
 * @method defaultLogFormatter
 * @param  {LogEntry} entry
 */
export default function defaultLogFormatter (entry) {
  // Compile the meta info of the log for a prefix.
  const { timestamp, level, target } = entry

  // Find a short name to reference which Logger this log is from.
  //    This is mostly to cut down the ID if it's too long for a human to read.
  const shortId = target.id && target.id.length > 8 ? target.id.substring(0, 6) : target.id
  const shortName = shortId ? `${target.type}/${shortId}` : target.type

  const logInfo = `${timestamp} - ${shortName} - ${level}`

  // Assume that the first message parameter is a string.
  const log = entry.messages[0]

  return `${logInfo} - ${log}`
}
